import { render, staticRenderFns } from "./LegalMentions.vue?vue&type=template&id=7771a3a3&scoped=true&"
import script from "./LegalMentions.vue?vue&type=script&lang=js&"
export * from "./LegalMentions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7771a3a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7771a3a3')) {
      api.createRecord('7771a3a3', component.options)
    } else {
      api.reload('7771a3a3', component.options)
    }
    module.hot.accept("./LegalMentions.vue?vue&type=template&id=7771a3a3&scoped=true&", function () {
      api.rerender('7771a3a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/option/LegalMentions.vue"
export default component.exports